import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'commentActive',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-comment-active wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g class="wd-icon-container"><path d="M8 11.5c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5zm0-3c0-.3.2-.5.5-.5h6c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-6c-.3 0-.5-.2-.5-.5zM18.5 8C17.1 8 16 6.9 16 5.5S17.1 3 18.5 3 21 4.1 21 5.5 19.9 8 18.5 8Z" class="wd-icon-accent"/><path d="M14 4.5v1c0 .3-.2.5-.5.5H6v9h12v-4.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v6c0 .3-.2.5-.5.5H11l-3.8 2.8H7V17H4.5c-.3 0-.5-.2-.5-.5v-12c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5Z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-comment-active.svg',
    category: 'Core',
    tags: ['active', 'message'],
};
export default icon;
